import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Heart, Check } from 'lucide-react';

const VOYAGE_IMG = 'https://customer-assets.emergentagent.com/job_flyout-travel/artifacts/fa57xjne_cap-vert-02-1500x630.jpg';

const VoyageEffectue = () => {
  return (
    <>
      <Header />
      <section
        id="voyage-effectue"
        data-testid="voyage-effectue-section"
        className="relative min-h-screen flex items-center justify-center overflow-hidden pt-28 pb-16"
      >
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${VOYAGE_IMG})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-charcoal/85 via-charcoal/75 to-charcoal/90"></div>
        </div>

        <div className="relative z-10 max-w-3xl mx-auto px-6 text-center text-cream-100">
          <div className="inline-flex items-center gap-3 mb-8 px-6 py-2.5 bg-gold-500/20 backdrop-blur-md border border-gold-300/40 rounded-full">
            <Check className="w-4 h-4 text-gold-300" />
            <span className="text-sm tracking-[0.25em] text-gold-200 uppercase">Voyage réalisé</span>
          </div>

          <p className="text-lg md:text-xl font-light tracking-[0.3em] text-gold-200 mb-3 uppercase">Cap-Vert</p>

          <h1 className="text-6xl md:text-7xl font-light mb-8 leading-none">
            <span className="bg-gradient-to-r from-gold-200 via-gold-300 to-gold-400 bg-clip-text text-transparent">2026</span>
          </h1>

          <p className="text-xl md:text-2xl font-light leading-relaxed text-cream-100/90 mb-8">
            Ce voyage a bien été réalisé.
          </p>

          <div className="flex items-center justify-center gap-3 text-gold-100">
            <Heart className="w-6 h-6 fill-gold-300 text-gold-300" />
            <p className="text-2xl md:text-3xl italic font-light">
              Un immense merci à toutes 💛
            </p>
          </div>

          <p className="mt-10 text-base md:text-lg font-light italic text-gold-200 tracking-wide">
            Avec Fly, tes secrets sont bien gardés. 🤫
          </p>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default VoyageEffectue;
